import { Button, Flex, Text } from '@everlywell/ui-kit';
import React from 'react';
import { QuestLocation } from 'utils/api/questApis';

export type QuestLocationListItemProps = {
  /** This is the text that is displayed in the component*/
  location: QuestLocation;
  handleOnClick: React.MouseEventHandler<HTMLButtonElement>;
};

/**
 * [Add the description for what this component does here].
 */
const QuestLocationListItem = ({
  location,
  handleOnClick,
}: QuestLocationListItemProps) => (
  <Button
    variant={'primary'}
    colorScheme="whiteCS"
    key={location.id}
    borderRadius="12px"
    borderWidth="1px"
    borderStyle={'solid'}
    borderColor={'tints.darkCream'}
    padding={4}
    display={'flex'}
    textAlign={'left'}
    justifyContent={'space-between'}
    onClick={handleOnClick}
    width={'100%'}
    aria-label={`Select Quest Diagnostics location at ${location.address}`}
  >
    <Flex flexDirection={'column'} aria-hidden>
      <Text size={'lg'}>Quest Diagnostics</Text>
      <Text
        size={'md'}
        color={'tints.darkGrey'}
        whiteSpace="normal"
        wordBreak="break-word"
        width={['60%', '100%']}
      >
        {location.address}, {location.city}, {location.state}{' '}
        {location.zip_code.split('-')[0]}
      </Text>
    </Flex>
    <Flex flexDirection={'column'}>
      <Text size="lg" fontWeight={'medium'}>
        {location.distance.toFixed(1)} mi
      </Text>
      <Text size="md" color={'tints.uiGrey'}>
        Away
      </Text>
    </Flex>
  </Button>
);

export default QuestLocationListItem;
